@if (data.canChange) {
  <span class="rule-status-label-wrapper" [ngClass]="{ 'status-on': data.enabled }">
    <select
      class="ps-2 pe-4 py-1 rule-status-label dropdown"
      [(ngModel)]="data.enabled"
      [ngClass]="{ 'status-on': data.enabled }"
      (change)="showChangeRuleStatusDialog()"
    >
      <option [ngValue]="true">{{ 'label_on' | translate }}</option>
      <option [ngValue]="false">{{ 'label_off' | translate }}</option>
    </select>
  </span>
} @else {
  <ds-chip
    [text]="(data.enabled ? 'label_on' : 'label_off') | translate"
    [colorVariant]="data.enabled ? DsChipColorVariant.Success : DsChipColorVariant.Danger"
  ></ds-chip>
}
<div class="d-inline-block ms-3">
  @if (data.changeLog.length > 0) {
    <app-view-rule-history [ruleTitle]="data.title" [historyInput]="data.changeLog"></app-view-rule-history>
  }
</div>
